import get from 'lodash/fp/get';
import { createSelector } from 'reselect';

import { getRouteKey } from 'selectors';

const getContentArchive = createSelector(
  [getRouteKey, get('archive')],
  (routeKey, archiveState) => archiveState[routeKey],
);

export default getContentArchive;
